import ImagesFooterSocialsFacebookSvg from '@/public/images/footer/socials/facebook.svg';
import ImagesFooterSocialsInstagramSvg from '@/public/images/footer/socials/instagram.svg';
import ImagesFooterSocialsYoutubeSvg from '@/public/images/footer/socials/youtube.svg';

export {
  ImagesFooterSocialsFacebookSvg,
  ImagesFooterSocialsInstagramSvg,
  ImagesFooterSocialsYoutubeSvg,
};
